import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Modal, Loading } from '@brighterion/br-ui';
import styles from './styles.css';

interface Props {
    closeModal(): void;
}

const DeployModalLoading = ({ closeModal }: Props) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal.Title
                id='deploy-modal-title'
                title={t('Review Deployment')}
                onClose={closeModal}
                showCloseIcon={false}
                statusIcon='warning'
            />
            <div className={clsx(styles.modalContent, styles.loadingContent)}>
                <p>Processing Deployment Updates...</p>
                <Loading size='xlg' fillName='dark-orange' />
            </div>
            <Modal.Footer id='deploy-footer' onClose={closeModal} />
        </>
    );
};

export default React.memo(DeployModalLoading);
